export default "__VITE_ASSET__j4jwh87U__"